import React, { useState, useEffect } from "react";

interface KillNotificationProps {
  victimName: string;
  onClose: () => void;
}

const KillNotification: React.FC<KillNotificationProps> = ({
  victimName,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Show the notification for 4 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 500); // Allow time for fade-out animation
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`fixed inset-0 bg-red-900 bg-opacity-70 flex flex-col items-center justify-center z-40 transition-opacity duration-500 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="max-w-md mx-auto p-4 text-center">
        <h2 className="text-3xl font-bold mb-4 text-white">
          A Murder Has Occurred!
        </h2>

        <div className="mb-6">
          <img
            src="/assets/images/MafiaKill.png"
            alt="Mafia Kill"
            className="mx-auto max-h-80 rounded shadow-lg"
          />
        </div>

        <p className="text-2xl text-red-300 mb-6">
          {victimName} was killed during the night!
        </p>
      </div>
    </div>
  );
};

export default KillNotification;
